/* import __COLOCATED_TEMPLATE__ from './opted-out-card.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import templateOnlyComponent from '@ember/component/template-only';
import type ModelTrainingConsentOptOutRequest from 'embercom/models/model-training-consent-opt-out-request';

interface OptedOutCardSignature {
  Args: {
    dataSharingOptOut: ModelTrainingConsentOptOutRequest | null | undefined;
  };
}

const OptedOutCard = templateOnlyComponent<OptedOutCardSignature>();

export default OptedOutCard;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::SecurityModelsDataSharing::OptedOutCard': typeof OptedOutCard;
  }
}
